module.exports = __webpack_public_path__ + "img/logoFS.7d1201c0.svg";